import * as tslib_1 from "tslib";
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { SessionStorageService, SessionStorage } from 'ngx-webstorage';
import { ApplicationService } from 'services/application/application.service';
import * as i0 from "@angular/core";
import * as i1 from "../application/application.service";
import * as i2 from "ngx-webstorage";
import * as i3 from "@angular/router";
var UserService = /** @class */ (function () {
    function UserService(appSvc, storage, route, router, sessionService) {
        this.appSvc = appSvc;
        this.storage = storage;
        this.route = route;
        this.router = router;
        this.sessionService = sessionService;
        this.UserSubject = new BehaviorSubject(null);
        this.UserSubject.next(this._User);
    }
    Object.defineProperty(UserService.prototype, "User", {
        get: function () {
            return this._User;
        },
        set: function (_ui) {
            this._User = _ui;
            this.UserSubject.next(_ui);
        },
        enumerable: true,
        configurable: true
    });
    // #region Clear User Service Call
    UserService.prototype.ClearUser = function () {
        this.User = null;
        this.sessionService.clear('_User');
        // Clear out all session specific settings.
        this.storage.clear('LastSearchResults');
        this.storage.clear('LastSearchOptions');
        this.storage.clear('SuppressOutOfOfficeAlert');
        this.storage.clear('_AllSubordinatesSupervisorSAPID');
        this.storage.clear('_AllSubordinates');
        this.appSvc.CurrentRequest = null;
    };
    // #endregion
    // #region Set Designee Edit Rights Service Call
    UserService.prototype.SetDesigneeEditRights = function (rights) {
        var newUser = JSON.parse(JSON.stringify(this.User));
        this.User = newUser;
    };
    // #endregion
    // #region Set User Service Call
    UserService.prototype.SetUser = function (user) {
        // const currole = this.User && this.User.CurrentRole;
        // user.CurrentRole = currole;
        this.User = user;
    };
    // #endregion
    // #region Set User Current Role Service Call
    UserService.prototype.SetUserCurrentRole = function (role) {
        if (this.User.CurrentRole != null && role === this.User.CurrentRole) {
            return;
        }
        // To trigger proper session storage, we need to create a new object reference, rather than just updating our existing User object.
        var newUser = JSON.parse(JSON.stringify(this.User));
        // Update the current role field.
        newUser.CurrentRole = role;
        // If the current role will now be 'Cabinet', look to see if the user has an active Out of Office setting for that role.
        if (role === 'Cabinet') {
            var cabRole = newUser.Roles.find(function (r) { return r.RoleName === 'Cabinet'; });
            newUser.OutOfOfficeActive = cabRole && cabRole.OutOfOfficeActive;
        }
        else {
            // Other roles cannot have Out of Office settings, so shut down the flag.
            newUser.OutOfOfficeActive = false;
        }
        // Now, persist it to session storage and then broadcast it for listeners.
        this.User = newUser;
        // Go to the home screen for this role.
        var homeroute = "/home";
        this.router.navigate([homeroute]);
    };
    // #endregion
    // #region Update AuthToken Service Call
    UserService.prototype.UpdateAuthToken = function (AuthToken) {
        // If the authtoken has changed, update the user record.
        if (AuthToken !== this.User.AuthToken) {
            // To trigger proper session storage, we need to create a new object reference, rather than just updating our
            // existing User object.
            var newUser = JSON.parse(JSON.stringify(this.User));
            // Update the AuthToken field
            newUser.AuthToken = AuthToken;
            // Now, persist it to session storage and then broadcast it for listeners
            this.User = newUser;
        }
    };
    UserService.ngInjectableDef = i0.defineInjectable({ factory: function UserService_Factory() { return new UserService(i0.inject(i1.ApplicationService), i0.inject(i2.SessionStorageService), i0.inject(i3.ActivatedRoute), i0.inject(i3.Router), i0.inject(i2.SessionStorageService)); }, token: UserService, providedIn: "root" });
    tslib_1.__decorate([
        SessionStorage(),
        tslib_1.__metadata("design:type", UserInfo)
    ], UserService.prototype, "_User", void 0);
    return UserService;
}());
export { UserService };
// #region Custom Classes
// #region Designee Edit Rights Class
var DesigneeEditRights = /** @class */ (function () {
    function DesigneeEditRights() {
    }
    return DesigneeEditRights;
}());
export { DesigneeEditRights };
// #endregion
// #region User Info Class
var UserInfo = /** @class */ (function () {
    function UserInfo() {
    }
    return UserInfo;
}());
export { UserInfo };
// #endregion
// #region User Role Class
var UserRole = /** @class */ (function () {
    function UserRole() {
    }
    return UserRole;
}());
export { UserRole };
// #endregion
// #region User Role Info Class
var UserRoleInfo = /** @class */ (function () {
    function UserRoleInfo() {
    }
    return UserRoleInfo;
}());
export { UserRoleInfo };
